export default __webpack_public_path__ + "static/media/img9.05315fa9.png";